{
  "title": "Stoneskin",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level abjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (diamond dust worth 100 gp, which the spell consumes)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "This spell turns the flesh of a willing creature you touch as hard as stone. Until the spell ends, the target has resistance to nonmagical bludgeoning, piercing, and slashing damage."
  ],
  "spellLists": ["artificer", "druid", "eldritch-knight", "ranger", "sorcerer", "wizard"]
}
